import React from 'react';
import { Route, Redirect, useParams, useLocation } from 'react-router-dom';
import { useFeatures } from '../context/FeatureContext';
import { featureAccess } from '../commercial/access';
import HistoricalFeatureNotice from './HistoricalFeatureNotice';

export const FeatureBoundary = ({ feature, intent = 'write', children }) => {
  const state = useFeatures();
  const { companyId } = useParams();
  const location = useLocation();
  const access = featureAccess(state, feature, intent);
  if (access === 'loading') return <div role="status" className="p-4">Hämtar åtkomst…</div>;
  if (access === 'error') return <div role="alert" className="alert alert-warning m-3">Kunde inte kontrollera din åtkomst. <button className="btn btn-outline-primary ms-2" onClick={state.refreshEntitlements}>Försök igen</button></div>;
  if (access === 'denied') return <Redirect to={{ pathname: `/${companyId}/feature-disabled`, state: { feature, from: location, historicalWrite: intent !== 'read' && state.entitlements?.historicalFeatures?.[feature] === true } }} />;
  const readOnly = access === 'historical';
  return <>{readOnly && <HistoricalFeatureNotice feature={feature} />}{typeof children === 'function' ? children({ commercialReadOnly: readOnly }) : children}</>;
};

export const FeatureRoute = ({ component: Component, render, feature, intent = 'write', ...rest }) => <Route {...rest} render={props =>
  <FeatureBoundary feature={typeof feature === 'function' ? feature(props) : feature} intent={intent}>
    {access => render ? render({ ...props, ...access }) : <Component {...props} {...access} />}
  </FeatureBoundary>
} />;
